import Login from "../../components/login/login.component"

const LoginPage = () => {
    return (
        <div>
            <Login />
        </div>
    )
}

export default LoginPage